import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';

const convertToDataTable = (data: IGetLineEnds[]): IGetLineEnds[] => {
  const dataTableData: IGetLineEnds[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}


const getAllLineEnds =  async(unitid:number | undefined): Promise<IGetLineEnds[]> => {
  const  response = await axiosDefaultApi.get(`/api/Atm/GetLineEndsOfAtmViaUnitID/${unitid}` );
  return convertToDataTable(response as unknown as IGetLineEnds[]);
};

type QueryFnType = typeof getAllLineEnds;

type UseGetAllLineEndsOptions = {
  unitid:number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllLineEnds = ({ config, unitid}: UseGetAllLineEndsOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllLineEnds'],
    queryFn: () => getAllLineEnds(unitid),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};